export default {
  NEWEST: '-id',
  OLDEST: 'id',
  LATEST_ACTIVITY_DATE: '-latestActivityDate',
  MOST_LIKED: '-likesCount',
  DISPLAY_NAME: 'DisplayName',
  NAME: 'Name',
};
